// extracted by mini-css-extract-plugin
export var hidden = "_sf-0";